"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmployeeBrandsInfo = /** @class */ (function () {
    function EmployeeBrandsInfo(source) {
        this.brandId = source ? source.brandId : -1;
        this.brandName = source ? source.brandName : '';
        this.description = source ? source.description : '';
        this.geoMarksCount = source ? source.geoMarksCount : 0;
    }
    return EmployeeBrandsInfo;
}());
exports.EmployeeBrandsInfo = EmployeeBrandsInfo;
//# sourceMappingURL=EmployeeBrandsInfo.js.map